export const styleSheet = theme => {
    const dashboardRow = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: `inset 0 -1px 0 0 ${theme.colors.gray03}`,
        backgroundColor: theme.colors.gray10,
        padding: '10px 20px',
        div: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
        },
        '> svg': {
            transition: 'all 0.2s ease-in-out',
            transform: 'rotate(90deg)'
        },
        p: {
            letterSpacing: 1,
            marginLeft: 10
        },
        a: {
            ':hover': {
                'svg g': {
                    fill: theme.colors.blue08
                }
            }
        }
    };
    return {
        tableHeaderRowShadow: {
            boxShadow: '0 1px 4px 0 rgba(66,65,82,0.06)',
            th: {
                height: 22,
                position: 'sticky',
                top: 22,
                zIndex: 3,
                backgroundColor: theme.colors.white01,
                ':last-of-type': {
                    paddingRight: theme.margins.margin01
                }
            }
        },
        tableHeaderColumnLabel: {
            textAlign: 'right',
            boxShadow: `inset 0 -1px 0 0 ${theme.colors.gray09}`,
            color: theme.colors.gray06,
            letterSpacing: '1px',
            padding: `0 ${theme.margins.margin01} 7px 0`,
            whiteSpace: 'nowrap'
        },
        tableHeaderGroupLabel: {
            textAlign: 'center',
            borderTop: `1px solid ${theme.colors.gray09}`,
            whiteSpace: 'nowrap',
            color: theme.colors.gray08,
            letterSpacing: '1px',
            padding: '8px 0 0',
            height: '22px'
        },
        tableHeaderTitle: {
            textAlign: 'left',
            boxShadow: `inset -1px 0 0 0 ${theme.colors.gray03}, inset 0 -1px 0 0 ${theme.colors.gray09}`,
            borderTop: `1px solid ${theme.colors.gray09}`,
            padding: `11px 0 12px ${theme.margins.margin01}`,
            whiteSpace: 'nowrap',
            zIndex: 3
        },
        headerTitleWrapper: {
            position: 'relative',
            color: theme.colors.black01,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
            paddingRight: '15px'
        },
        tableHeaderRow: {
            th: {
                position: 'sticky',
                top: 0,
                zIndex: 3,
                backgroundColor: theme.colors.white01,
                ':first-of-type': {
                    paddingLeft: theme.margins.margin01
                }
            }
        },
        tableRowExpanded: {
            backgroundColor: theme.colors.blue09,
            td: {
                position: 'sticky',
                top: 43,
                zIndex: 2,
                backgroundColor: theme.colors.blue09
            }
        },
        tableRow: {
            td: {
                zIndex: 1,
                position: 'relative'
            },
            ':hover': {
                td: {
                    backgroundColor: theme.colors.yellow01
                }
            }
        },
        tableRowLast: {
            td: {
                zIndex: 1,
                position: 'relative',
                boxShadow: 'unset',
                ':first-of-type': {
                    boxShadow: `inset -1px 0 0 0 ${theme.colors.gray03}`
                }
            },
            ':hover': {
                td: {
                    backgroundColor: theme.colors.yellow01
                }
            }
        },
        tableRowTitle: {
            width: '235px',
            boxShadow: `inset -1px 0 0 0 ${theme.colors.gray03}, inset 0 -1px 0 0 ${theme.colors.gray03}`,
            verticalAlign: 'middle',
            position: 'relative',
            paddingLeft: theme.margins.margin01,
            paddingTop: '8px',
            paddingBottom: '9px',
            '.removeMonitorButton': {
                visibility: 'hidden',
                [`@media(max-width: ${theme.breakpoints.internal.mobile})`]: {
                    visibility: 'visible'
                }
            },
            ':hover': {
                '.removeMonitorButton': {
                    visibility: 'visible'
                }
            },
            [`@media(max-width: ${theme.breakpoints.internal.mobile})`]: {
                width: '225px'
            }
        },
        rowSubtext: {
            marginTop: '2px',
            letterSpacing: '1px',
            color: theme.colors.gray04
        },
        rowTitleText: {
            textTransform: 'capitalize',
            whiteSpace: 'normal',
            lineHeight: '1.1em'
        },
        rowTitleWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        tableRowValue: {
            verticalAlign: 'middle',
            boxShadow: `inset 0 -1px 0 0 ${theme.colors.gray03}`,
            padding: `8px ${theme.margins.margin01} 9px 0`,
            p: {
                textAlign: 'right'
            }
        },
        titlePlus: {
            display: 'flex',
            cursor: 'pointer',
            alignItems: 'center',
            p: {
                marginLeft: theme.margins.margin00
            },
            ':hover': {
                color: theme.colors.blue08,
                p: {
                    color: theme.colors.blue08
                },
                'svg g': {
                    fill: theme.colors.blue08
                }
            }
        },
        plusButton: {
            marginLeft: theme.margins.margin01
        },
        loadingCell: {
            borderBottom: `1px solid ${theme.colors.gray03}`
        },
        loadingContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80px'
        },
        noMatchesCell: {
            position: 'relative',
            zIndex: 2,
            backgroundColor: theme.colors.white01,
            borderBottom: `1px solid ${theme.colors.gray09}`
        },
        noDifferentials: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80px',
            p: {
                color: theme.colors.gray04,
                marginRight: '14px'
            }
        },
        removeMonitorButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '24px',
            width: '24px',
            background: theme.colors.white03,
            borderRadius: '6px',
            marginRight: '14px',
            cursor: 'pointer',
            flexShrink: 0,
            svg: {
                width: 12
            },
            ':hover': {
                backgroundColor: theme.colors.gray01,
                'svg g': {
                    fill: theme.colors.blue08
                }
            }
        },
        dashboardRow: {
            ...dashboardRow
        },
        dashboardRowCollapsed: {
            ...dashboardRow,
            div: {
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
            },
            '> svg': {
                transition: 'all 0.2s ease-in-out',
                transform: 'rotate(180deg)'
            }
        },
        removeMonitorLoader: {
            marginRight: 6,
            marginLeft: 6
        },
        titleToggle: {
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
            svg: {
                transition: 'all 0.2s ease-in-out',
                transform: 'rotate(90deg)'
            }
        },
        titleToggleHidden: {
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
            svg: {
                transition: 'all 0.2s ease-in-out',
                transform: 'rotate(180deg)'
            }
        }
    };
};
